import {
  Button,
  Card,
  Col,
  message,
  Row,
  Table,
  Input,
  Modal,
  Select,
} from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useHistory, withRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { strings } from "res";
import { fetchAllDewan, deleteDewan } from "redux/features/dewan";
import moment from "moment";
import { fetchAllCategory } from "redux/features/category";
import { capitalize, filter } from "lodash";
import { fetchAllSubcategory } from "redux/features/subcategory";
import { fetchAllKomisi } from "redux/features/komisi";
import { fetchAllFraksi } from "redux/features/fraksi";

// {
//   "id": 1,
//   "fraksi_id": 1,
//   "komisi_id": null,
//   "name": "Abdul Rais",
//   "education": "S1",
//   "description": "lorem ipsum",
//   "email": "abdulrais@gmail.com",
//   "jabatan_fraksi": "anggota",
//   "jabatan_komisi": "ketua",
//   "instagram": "https://www.instagram.com/abdulrais",
//   "website": "https://www.abdulrais.com",
//   "photo": "http://api.banyuasinkab.info/uploads/1736853940554-Abdul_Rais.jpgg",
//   "fraksi": {
//     "id": 1,
//     "name": "Partai Gerakan Indonesia Raya"
//   },
//   "komisi": null
// }

const LocalizedModal = () => {
  const [open, setOpen] = useState(false);
  const showModal = () => {
    setOpen(true);
  };
  const hideModal = () => {
    setOpen(false);
  };
  return (
    <>
      <Modal
        title="Modal"
        open={open}
        onOk={hideModal}
        onCancel={hideModal}
        okText="Ok"
        cancelText="Cancel"
      >
        <p>Bla bla ...</p>
        <p>Bla bla ...</p>
        <p>Bla bla ...</p>
      </Modal>
    </>
  );
};

const jabatanMap = {
  anggota: "Anggota",
  ketua: "Ketua",
  sekretaris: "Sekretaris",
  "wakil ketua": "Wakil Ketua",
};

const komisiMap = {
  "komisi-1": "Komisi I",
  "komisi-2": "Komisi II",
  "komisi-3": "Komisi III",
  "komisi-4": "Komisi IV",
};

export const DEWAN = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [metaData, setMetaData] = useState({});
  const [totalData, setTotalData] = useState(0);
  const [modal, contextHolder] = Modal.useModal();
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);

  const [filters, setFilters] = useState({
    page: 1,
    limit: 10,
    sort: "created_at",
    total_data: 0,
  });

  const tableColumns = [
    {
      title: "No",
      key: "no",
      render: (_text, _record, index) =>
        (filters.page - 1) * filters.limit + index + 1,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: "250px",
      render: (text) => (
        <div
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            textAlign: "left",
            display: "flex",
            alignItems: "center",
            minHeight: "60px",
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: "Foto",
      dataIndex: "photo",
      key: "photo",
      render: (_, record) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "60px",
          }}
        >
          <img
            src={record.photo}
            alt={record.name}
            style={{
              width: "50px",
              height: "60px",
              objectFit: "cover",
              borderRadius: "4px",
            }}
          />
        </div>
      ),
      align: "center",
    },
    {
      title: "Fraksi",
      dataIndex: "fraksi",
      key: "fraksi",
      render: (_, record) => (
        <div style={{ margin: "auto", display: "flex" }}>
          {record.fraksi?.name}
        </div>
      ),
    },
    {
      title: "Jabatan Fraksi",
      dataIndex: "jabatan_fraksi",
      key: "jabatan_fraksi",
      render: (text) => (
        <div style={{ textAlign: "center" }}>
          {jabatanMap[text?.toLowerCase()] || text || "-"}
        </div>
      ),
    },
    {
      title: "Komisi",
      dataIndex: "komisi",
      key: "komisi",
      render: (_, record) => (
        <div style={{ textAlign: "center" }}>
          {komisiMap[record.komisi?.name?.toLowerCase()] ||
            record.komisi?.name ||
            "-"}
        </div>
      ),
    },
    {
      title: "Jabatan Komisi",
      dataIndex: "jabatan_komisi",
      key: "jabatan_komisi",
      render: (text) => (
        <div style={{ textAlign: "center" }}>
          {jabatanMap[text?.toLowerCase()] || text || "-"}
        </div>
      ),
    },
    {
      title: () => <div className="text-center">Detail</div>,
      key: "detail",
      render: (_, record) => (
        <div className="text-center">
          <Button
            type="primary"
            style={{ textAlign: "center" }}
            onClick={() => {
              history.push({
                pathname: `${strings.navigation.path.detail_dewan}`,
                state: record,
              });
            }}
          >
            Detail
          </Button>
        </div>
      ),
    },
    {
      title: () => <div className="text-center">Action</div>,
      key: "status",
      render: (_, record) => (
        <div className="text-center">
          <Button
            type="danger"
            style={{ textAlign: "center", color: "white" }}
            onClick={() => {
              confirm(record.id);
            }}
          >
            Delete
          </Button>
        </div>
      ),
    },
  ];

  const getData = async (params) => {
    try {
      setLoading(true);
      const response = await dispatch(fetchAllDewan(params)).unwrap();
      setMetaData(response.meta.page);
      setData(response.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const getCategories = async () => {
    try {
      const response = await dispatch(fetchAllKomisi()).unwrap();
      setCategories(
        response.data.map((category) => {
          return {
            value: category.id,
            label: category.nomor,
          };
        })
      );
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const getSubcategories = async () => {
    try {
      const response = await dispatch(
        fetchAllFraksi({
          limit: 100,
        })
      ).unwrap();
      setSubcategories(
        response.data.map((subcategory) => {
          return {
            label: capitalize(subcategory.name),
            value: subcategory.name,
          };
        })
      );
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const confirm = (id) => {
    modal.confirm({
      title: "Are you sure?",
      icon: <ExclamationCircleOutlined />,
      content: "Are you sure wanna delete this?",
      okText: "Yes",
      cancelText: "No",
      onOk: async () => {
        await dispatch(deleteDewan(id));
        getData(filters);
      },
      onCancel: () => {},
    });
  };

  const handleCategorySelect = (val) => {
    setFilters({ ...filters, komisi: val });
  };

  const handleSubcategorySelect = (val) => {
    console.log("val", val);
    setFilters({ ...filters, fraksi: val });
  };

  const handleSearchByTitle = (event) => {
    setFilters({
      ...filters,
      name: event.target.value ? event.target.value : undefined,
    });
  };

  const handleTableChange = (pagination, filter, sorter) => {
    let sorterKey = "";

    setFilters({ ...filters, page: pagination.current });

    if (sorter.field === "date_published" && sorter.order) {
      sorterKey = sorter.order === "ascend" ? sorter.field : `-${sorter.field}`;
      setFilters({
        ...filters,
        page: 1,
        sort: sorterKey,
        page: pagination.current,
      });
    }

    if (sorter.field === "created_at" && sorter.order) {
      sorterKey = sorter.order === "ascend" ? sorter.field : `-${sorter.field}`;
      setFilters({
        ...filters,
        page: 1,
        sort: sorterKey,
        page: pagination.current,
      });
    }
  };

  useEffect(() => {
    getData(filters);
    getCategories();
    getSubcategories();
    // getTags();
  }, [filters]);

  // useMemo(() => {
  //   getData(filters);
  // }, []);

  return (
    <>
      <LocalizedModal></LocalizedModal>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <h2>Anggota Dewan</h2>
          <p>Tampilkan semua anggota dewan beserta data dewan.</p>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Card>
            <Row gutter={[16, 2]}>
              <Col xs={24} sm={24} md={12} lg={12} span={6}>
                <Input
                  placeholder="Cari Berdasarkan Nama"
                  onSelect={handleSearchByTitle}
                  className="mb-4 mr-4"
                  allowClear
                  style={{ width: "100%" }}
                />
              </Col>
              <Col xs={24} sm={24} md={6} lg={6} span={6}>
                <Select
                  placeholder="Filter Berdasarkan Komisi"
                  onSelect={handleCategorySelect}
                  options={categories}
                  className="mb-4 mr-4"
                  allowClear
                  onClear={handleCategorySelect}
                  style={{ width: "100%" }}
                />
              </Col>
              <Col xs={24} sm={24} md={6} lg={6} span={6}>
                <Select
                  placeholder="Filter Berdasarkan Fraksi"
                  onSelect={handleSubcategorySelect}
                  options={subcategories}
                  className="mb-4 mr-4"
                  allowClear
                  onClear={handleSubcategorySelect}
                  style={{ width: "100%" }}
                />
              </Col>
            </Row>
            {/* <Select
              placeholder="Filter by tags"
              onSelect={handleTagSelect}
              options={tags}
              className="mb-4 mr-4"
              allowClear
              onClear={handleTagSelect}
            /> */}
            <Table
              className="no-border-last"
              style={{ textAlign: "center", margin: "auto" }}
              scroll={{ x: "100%" }} // Menambahkan scrolling horizontal
              columns={tableColumns}
              dataSource={data}
              rowKey="id"
              loading={isLoading}
              pagination={{
                defaultPageSize: 10,
                defaultCurrent: metaData.page,
                total: metaData.total_data,
                showSizeChanger: true,
              }}
              onChange={handleTableChange}
            />
          </Card>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Button
            type="primary"
            style={{ border: "0px" }}
            htmlType="submit"
            onClick={() => {
              history.push({
                pathname: `${strings.navigation.path.detail_dewan}`,
              });
            }}
            block
          >
            Tambah Anggota Dewan
          </Button>
        </Col>
      </Row>
      {contextHolder}
    </>
  );
};

export default withRouter(DEWAN);
